import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { queryOptions } from '@tanstack/react-query';
import type { ProductClaim } from '../types/product-claim.type';

export type GetProductClaimParams = {
  klaim_produk_id: string;
};
export type GetProductClaimResponse = ApiResponse<ProductClaim>;

export const getProductClaim = async (
  params: GetProductClaimParams
): Promise<GetProductClaimResponse> => {
  const { klaim_produk_id } = params;
  const url = `product-promotion/${klaim_produk_id}`;

  return await apiClient.get(url);
};

export function getProductClaimQueryOptions(params: GetProductClaimParams) {
  return queryOptions({
    queryKey: ['klaim-produk', params.klaim_produk_id],
    queryFn: () => getProductClaim(params),
  });
}
